import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=13860741&scoped=true"
import script from "./OnboardingHeader.vue?vue&type=script&lang=js"
export * from "./OnboardingHeader.vue?vue&type=script&lang=js"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=13860741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13860741",
  null
  
)

export default component.exports